import React, {Component} from "react";
import {Get, Add} from "../../api/Menu";
import {Search as SearchPost} from "../../api/Post";
import Menu from "../Menu";
import {ReactComponent as ResultSearch} from "../../img/result-search.svg";
import {ReactComponent as SearchIcon} from "../../img/search.svg";
import {ReactComponent as SearchLoopIcon} from "../../img/search-icon.svg";
import {ReactComponent as Copy} from "../../img/copy.svg";
import { translate } from "../../dictionaries";
export default class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            query: "",
            menu: [],
            items: [],
            title: "",
            sub: "",
            sub2: "",
            step: 0,
            phone: false
        };
    }

    componentDidMount() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({
                phone: true
            })
          } else {
            this.setState({
                phone: false
            })
        }
        this.loadMenu();
    }

    loadSearch = async () => {
        const search = window.location.search.indexOf('search') > -1 ? window.location.search.replace("?search=", "") :  window.location.search.replace("?query=", "");
        const resp = await SearchPost(search);
        
        const data = await resp.json();

        this.setState({
            items: data,
            query: decodeURIComponent(search),
            loading: false
        })
    };

    loadSearchState = async () => {
        const resp = await SearchPost(this.state.query);
        
        const data = await resp.json();
        
        this.setState({
            items: data,
            query: decodeURIComponent(this.state.query),
            loading: false
        })
    };

    loadMenu = async () => {
        const path = window.location.pathname;

        const resp = await Get(path.replace("/", ""));

        const data = await resp.json();


        this.setState({

            menu: data.map((item) => {
                return {
                    id: item.id,
                    href: item.href,
                    isEdit: false,
                    isRoot: item.isRoot,
                    items: item.items,
                    menuId: item.menuId,
                    name: item.name,
                    postId: item.postId,
                }
            })
        }, () => {
            this.loadSearch();
        })
    };

    renderItems = (items) => {
        return items.map((item, key) => {
            const title = item.title;
            const index = title.indexOf(this.state.query);

            var result;
            var sub;
            var sub2;
            if (index === 0) {
                result = title.slice(index + this.state.query.length, title.length);
                sub = title.slice(0, this.state.query.length);
            } else if (index > 0) {
                sub = title.slice(0, index);
                sub2 = title.slice(index, this.state.query.length+1);
                result = title.slice(index + this.state.query.length, title.length);
            }

            
            return (
                <div class="content__box" style="display: flex;" style={{padding: 10, display: 'flex', padding: '40px 35px', borderBottom: '1px solid #eee'}}>
                    <div style={{paddingTop: 3, paddingRight: 15}}>
                        <Copy style={{width: 20, height: 20, background: '#F7F7F7', padding: 10, borderRadius: 3, marginRight: 10}}/>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', }}>
                        <a href={item.href} style={{cursor: "pointer", color: '#2f2f2f', fontWeight: 700, fontFamily: 'Calibri, sans-serif',paddingBottom: 3}}>
                        {
                            index === 0 && <><span style={{color: '#000', fontWeight: 700}}>{sub}</span><span>{result}</span></>
                        }
                        {
                            index === 1 && <><span>{sub}</span><span style={{color: '#000', fontWeight: 700}}>{sub2}</span><span>{result}</span></>
                        }
                        {
                            index === - 1 && <span>{item.title}</span>
                        }
                    </a>
                    <div
                        dangerouslySetInnerHTML={{__html: item.description}}
                        style={{cursor: 'pointer'}}
                        onClick={() => window.location.replace(window.location.origin+'/' + item.href)}>
                    </div>
                    </div>
                </div>
            )
        })
    };

    render() {
        return (
            <>
                {
                    this.state.loading &&
                    <div id="overlay">
                        <div className={"circle"}>
                        </div>
                    </div>
                }
                {
                    !this.state.loading &&
                    <>
                        <Menu
                            editable={true}
                            addChildMenu={this.addChildMenu}
                            addRootMenu={this.addRootMenu} menu={this.state.menu}
                            showBanner={this.props.showBanner}/>
                        <div className="site__content" style={{marginTop: this.props.showBanner && !this.state.phone ? 60 : 0}}>
                            <section class="content">
                                <div style={{display: 'flex', marginLeft: 45}}>
                                    <ResultSearch />
                                
                                    <h1 style={{marginLeft: 0}} class="content__title  content__title--icon" 
                                        style={{color: '#333333', fontFamily: 'Calibri, sans-serif', marginBottom: 0, fontSize: 26, fontWeight: 700, textTransform: 'uppercase'}}>
                                        {translate('common.searchResult')}:
                                    </h1>
                                </div>
                                <form className="nav__search" style={{marginLeft: 45, marginBottom: 40}}>
                                    <input value={this.state.query} type="text"
                                        onChange={(v) => {
                                            this.setState({
                                                query: v.target.value
                                            });
                                            this.loadSearchState();
                                        }
                                        }
                                        className="input nav__input-search" name="search" placeholder={translate('common.quantion')}/>
                                    <span
                                        onClick={() => this.loadSearchState()}
                                        className="nav__btn-search"
                                    >
                                        <SearchIcon/>
                                    </span>
                                </form>
                                <div style={{width: 880}}>
                                    {
                                        this.state.items.length
                                        ? this.renderItems(this.state.items)
                                        :   <div style={{border: '1px dashed #bfbfbf', width: '100%', display: 'flex', padding: '49px 46px 48px'}}>
                                                <div>
                                                    <SearchLoopIcon style={{width: 20, height: 20, fill: '#bfbfbf', padding: 10, border: '1px solid #e5e5e5', borderRadius: 8}}/>
                                                </div>
                                                <div style={{marginLeft: 28}}>
                                                    <p style={{color: '#333333', fontFamily: 'Calibri, sans-serif', fontSize: 16, fontWeight: 700, textTransform: 'uppercase', padding: 0, margin: 0, lineHeight: 1.7}}>{translate('common.pageNotFound')}</p>
                                                    <p style={{color: '#333333', fontFamily: 'Calibri, sans-serif', fontSize: 16, fontWeight: 300, padding: 0, margin: 0}}>{translate('common.changeSearch')}</p>
                                                </div>
                                            </div>
                                    }
                                </div>
                                
                                    
                            </section>
                        </div>
                    </>
                }
            </>
        )
    }
}